import React from 'react';
import LabeledField, { LabeledFieldProps } from './LabeledField';

type SupportedEnumTypes = Record<string, string>;

export type EnumFieldProps = LabeledFieldProps & {
  enumToUse: SupportedEnumTypes;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const EnumField = ({ name, enumToUse, as, ...rest }: EnumFieldProps) => {
  return (
    <LabeledField name={name} as='select' {...rest}>
      {Object.values(enumToUse).map((value, i) => (
        <option key={i} value={value}>
          {value}
        </option>
      ))}
    </LabeledField>
  );
};

export default EnumField;
